import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import {
  contractPartyContacts,
  type PartyContacts,
} from '@/utils/contractParties';
import { Contract } from '@/types/ContractType';

const PartyBlock = ({
  title,
  party,
}: {
  title: string;
  party: PartyContacts;
}) => (
  <>
    <Text style={styles.bold}>{title}:</Text>
    <View>
      {party.people.length === 0 && <Text>• N/A</Text>}
      {party.people.map((person, i) => (
        <Text key={i}>
          •{' '}
          {party.people.length > 1 && (
            <Text style={styles.subSection}>
              {person.name || `#${i + 1}`}:{' '}
            </Text>
          )}
          Email: <Text style={styles.subSection}>{person.email || 'N/A'}</Text>{' '}
          · Phone:{' '}
          <Text style={styles.subSection}>{person.phone || 'N/A'}</Text>
        </Text>
      ))}
      <Text>
        • Mailing Address:{' '}
        <Text style={styles.subSection}>{party.mailingAddress || 'N/A'}</Text>
      </Text>
    </View>
  </>
);

export const PartiesInfo = ({ contract }: { contract: Contract }) => {
  const { buyer, seller } = contractPartyContacts(contract);
  return (
    <View style={styles.section}>
      <Text style={styles.title}>PARTIES CONTACT INFORMATION</Text>
      <View>
        <PartyBlock title="Buyer Contact Information" party={buyer} />
        <PartyBlock title="Seller Contact Information" party={seller} />
      </View>
    </View>
  );
};
